export const authenticationConstants = {
  CHECK_EMAIL_REQUEST: 'AUTHENTICATION/CHECK_EMAIL_REQUEST',
  CHECK_EMAIL_SUCCESS: 'AUTHENTICATION/CHECK_EMAIL_SUCCESS',
  CHECK_EMAIL_FAILURE: 'AUTHENTICATION/CHECK_EMAIL_FAILURE',

  SEND_ACTIVATION_CODE_REQUEST: 'AUTHENTICATION/SEND_ACTIVATION_CODE_REQUEST',
  SEND_ACTIVATION_CODE_SUCCESS: 'AUTHENTICATION/SEND_ACTIVATION_CODE_SUCCESS',
  SEND_ACTIVATION_CODE_FAILURE: 'AUTHENTICATION/SEND_ACTIVATION_CODE_FAILURE',

  VALIDATE_ACTIVATION_CODE_REQUEST: 'AUTHENTICATION/VALIDATE_ACTIVATION_CODE_REQUEST',
  VALIDATE_ACTIVATION_CODE_SUCCESS: 'AUTHENTICATION/VALIDATE_ACTIVATION_CODE_SUCCESS',
  VALIDATE_ACTIVATION_CODE_FAILURE: 'AUTHENTICATION/VALIDATE_ACTIVATION_CODE_FAILURE',

  CREATE_ACCOUNT_REQUEST: 'AUTHENTICATION/CREATE_ACCOUNT_REQUEST',
  CREATE_ACCOUNT_SUCCESS: 'AUTHENTICATION/CREATE_ACCOUNT_SUCCESS',
  CREATE_ACCOUNT_FAILURE: 'AUTHENTICATION/CREATE_ACCOUNT_FAILURE',

  SEND_PASSWORD_RESET_LINK_REQUEST: 'AUTHENTICATION/SEND_PASSWORD_RESET_LINK_REQUEST',
  SEND_PASSWORD_RESET_LINK_SUCCESS: 'AUTHENTICATION/SEND_PASSWORD_RESET_LINK_SUCCESS',
  SEND_PASSWORD_RESET_LINK_FAILURE: 'AUTHENTICATION/SEND_PASSWORD_RESET_LINK_FAILURE',

  CHECK_PASSWORD_RESET_KEY_REQUEST: 'AUTHENTICATION/CHECK_PASSWORD_RESET_KEY_REQUEST',
  CHECK_PASSWORD_RESET_KEY_SUCCESS: 'AUTHENTICATION/CHECK_PASSWORD_RESET_KEY_SUCCESS',
  CHECK_PASSWORD_RESET_KEY_FAILURE: 'AUTHENTICATION/CHECK_PASSWORD_RESET_KEY_FAILURE',

  UPDATE_PASSWORD_REQUEST: 'AUTHENTICATION/UPDATE_PASSWORD_REQUEST',
  UPDATE_PASSWORD_SUCCESS: 'AUTHENTICATION/UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_FAILURE: 'AUTHENTICATION/UPDATE_PASSWORD_FAILURE',

  GET_SSO_USER_INFO_REQUEST: 'AUTHENTICATION/GET_SSO_USER_INFO_REQUEST',
  GET_SSO_USER_INFO_SUCCESS: 'AUTHENTICATION/GET_SSO_USER_INFO_SUCCESS',
  GET_SSO_USER_INFO_FAILURE: 'AUTHENTICATION/GET_SSO_USER_INFO_FAILURE',

  GET_SERVER_TOKEN_REQUEST: 'AUTHENTICATION/GET_SERVER_TOKEN_REQUEST',
  GET_SERVER_TOKEN_SUCCESS: 'AUTHENTICATION/GET_SERVER_TOKEN_SUCCESS',
  GET_SERVER_TOKEN_FAILURE: 'AUTHENTICATION/GET_SERVER_TOKEN_FAILURE',

  LOGIN_WITH_APP_REQUEST: 'AUTHENTICATION/LOGIN_WITH_APP_REQUEST',
  LOGIN_WITH_APP_SUCCESS: 'AUTHENTICATION/LOGIN_WITH_APP_SUCCESS',
  LOGIN_WITH_APP_FAILURE: 'AUTHENTICATION/LOGIN_WITH_APP_FAILURE'
}
